import { Close, CloseFullscreen, Launch, OpenInFull } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetApiDeliverablesByIdQuery } from '../../../../../app/athenaApiGen';
import {
  setExpandedPanel,
  setViewPanel,
} from '../../../../../app/deliverables/deliverablesSlice';
import { RootState } from '../../../../../app/store';
import {
  ViewHeaderContainer,
  ViewHeaderLabelContainer,
} from '../../../../../components/ViewPanel/StyledComponents';

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedRowId, expandedPanel } = useSelector(
    (state: RootState) => state.deliverables,
  );
  const { data } = useGetApiDeliverablesByIdQuery({ id: selectedRowId || '' });
  return (
    <ViewHeaderContainer>
      <ViewHeaderLabelContainer>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          {data?.deliverableTitle}
        </Typography>

        {(!data?.workflowState ||
          (!data?.workflowState.includes('Pending') &&
            !data?.workflowState.includes('No Workflow'))) && (
          <Typography
            sx={{
              display: 'flex',
              displayDirection: 'row',
              color: '#0092CB',
              p: 0,
              textDecorationLine: 'underline',
              cursor: 'pointer',
              gap: 0.25,
              alignItems: 'center',
            }}
            onClick={() => {
              navigate('/approvalQueue', {
                state: { id: data?.deliverableId, objectType: 'Deliverable' },
              });
            }}
          >
            <Launch sx={{ width: '20px !important' }} />
            {'Open in Approval Queue'}
          </Typography>
        )}
      </ViewHeaderLabelContainer>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          size="small"
          sx={{ color: '#0092CB' }}
          onClick={() => dispatch(setExpandedPanel(!expandedPanel))}
        >
          {expandedPanel ? <CloseFullscreen /> : <OpenInFull />}
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: '#0092CB' }}
          onClick={() => dispatch(setViewPanel(false))}
        >
          <Close />
        </IconButton>
      </Box>
    </ViewHeaderContainer>
  );
};

export default Header;
